// extracted by mini-css-extract-plugin
export default {"EmojiReactionsOverlay":"EmojiReactionsOverlay_EmojiReactionsOverlay__1jNYi","Emoji":"EmojiReactionsOverlay_Emoji__z7fEw"};